export default __webpack_public_path__ + "static/media/icon-arrow-blue.608bf32d.svg";